import { resolveAnchor, type AnchorSpec } from '../engine/anchors';
import { delay } from './formFill';

const FLASH_CLASS = 'tour-task-flash';
const FLASH_ROW_CLASS = 'tour-task-flash--row';

export async function flashElement(
  el: HTMLElement | null,
  { holdMs = 520, row = false }: { holdMs?: number; row?: boolean } = {},
): Promise<void> {
  if (!el) return;
  const className = row ? FLASH_ROW_CLASS : FLASH_CLASS;
  el.classList.add(className);
  await delay(holdMs);
  el.classList.remove(className);
}

export function flashAnchor(spec: AnchorSpec, options?: { holdMs?: number; row?: boolean }): Promise<void> {
  return flashElement(resolveAnchor(spec)?.element ?? null, options);
}

export function bringIntoView(el: HTMLElement | null): void {
  if (!el) return;
  try {
    el.scrollIntoView({ block: 'center', inline: 'nearest', behavior: 'auto' });
  } catch {
    el.scrollIntoView();
  }
}
